import { useMediaQuery } from "@mui/material";
import { LayoutMobile } from "./LayoutMobile";
import { Layout } from "./Layout";
import { ContentJson } from "../../model/ContentJson";

export const LayoutDispatch: React.FC<{contentJson: ContentJson}> = ({contentJson}) => {
    const media = useMediaQuery('(min-width:560px)');
    return ( 
        <>
            {media ? <Layout contentJson={contentJson} /> : <LayoutMobile contentJson={contentJson} />}
        </>
    )
}